<div class="flex flex-row gap-2">
  <div>{{ averageLoad?.value | number : '1.2-2' }}</div>
  <ui-icon
    [name]="difference === 1 ? 'rise' : difference === 2 ? 'fall' : 'minus'"
    [color]="difference === 1 ? '#4cb050' : difference === 2 ? '#f13d3d' : '#868686'"
    size="20px"
  ></ui-icon>
  <div>{{ averageLoadPercentage | number : '1.2-2' }}%</div>
</div>
